/**
 * 「我的」：顶部 HeroUI Tabs（账户设置、安全设置、第三方账户）。
 * 指示器须放在各 Tabs.Tab 内部，与官方 Basic 示例一致。
 */
import { Tabs } from '@heroui/react';
import { useSearchParams } from 'react-router-dom';
import { AccountSettings } from './components/AccountSettings';
import { SecuritySettings } from './components/SecuritySettings';
import {
  ThirdPartyAccountsSettings,
  TAB_THIRD_PARTY,
} from './components/ThirdPartyAccountsSettings';

const TAB_ACCOUNT = 'account';
const TAB_SECURITY = 'security';

export default function MyPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');
  const selectedKey =
    tabFromUrl === TAB_THIRD_PARTY
      ? TAB_THIRD_PARTY
      : tabFromUrl === TAB_SECURITY
        ? TAB_SECURITY
        : TAB_ACCOUNT;

  return (
    <div className="flex h-full min-h-0 flex-col bg-background">
      <Tabs
        selectedKey={selectedKey}
        onSelectionChange={(key) => {
          const next = new URLSearchParams(searchParams);
          if (key === TAB_ACCOUNT) {
            next.delete('tab');
          } else {
            next.set('tab', String(key));
          }
          setSearchParams(next, { replace: true });
        }}
        className="flex min-h-0 flex-1 flex-col w-full mx-auto"
      >
        <Tabs.ListContainer className="w-[26rem] mx-auto px-4">
          <Tabs.List aria-label="我的">
            <Tabs.Tab id={TAB_ACCOUNT}>
              账户设置
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={TAB_SECURITY}>
              安全设置
              <Tabs.Indicator />
            </Tabs.Tab>
            <Tabs.Tab id={TAB_THIRD_PARTY}>
              第三方账户
              <Tabs.Indicator />
            </Tabs.Tab>
          </Tabs.List>
        </Tabs.ListContainer>
        <Tabs.Panel id={TAB_ACCOUNT} className="min-h-0 flex-1 flex flex-col overflow-hidden">
          <AccountSettings />
        </Tabs.Panel>
        <Tabs.Panel id={TAB_SECURITY} className="min-h-0 flex-1 flex flex-col overflow-hidden">
          <SecuritySettings />
        </Tabs.Panel>
        <Tabs.Panel id={TAB_THIRD_PARTY} className="min-h-0 flex-1 flex flex-col overflow-hidden">
          <ThirdPartyAccountsSettings />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
}
